module.exports = __webpack_public_path__ + "img/carv_hoverd.d128f1d7.svg";